import { Skeleton as MuiSkeleton, SkeletonProps } from "@mui/material";
import React, { FC } from "react";

const Skeleton: FC<SkeletonProps> = (props) => {
    return <MuiSkeleton {...props} />
}

export default Skeleton;